// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rn-0";